import { render, staticRenderFns } from "./MedsSame.vue?vue&type=template&id=11b804f6"
import script from "./MedsSame.vue?vue&type=script&lang=js"
export * from "./MedsSame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports